import CrmInputField from "../../component/CrmUI/CrmProfileUI/CrmInputFields";
import CrmSelectField from "../../component/CrmUI/CrmProfileUI/CrmSelectField";
import { CrmUseAddProduct } from "../../features/Crm/CrmAddProduct/CrmUseAddProduct";

const CrmAddProduct = () => {
    const { formData,
        handleChange,
        handleSubmit,
        productUnits,
        gstRates,
        generateCode,
        isLoading } =
        CrmUseAddProduct();

    return (
        <div className="p-4 sm:p-6 lg:p-8">
            <h2 className="font-bold text-[#0a3021] text-[26px] mb-4 text-center lg:text-left">
                Add Product
            </h2>
            <form
                onSubmit={handleSubmit}
                className="bg-white shadow rounded-lg p-4 sm:p-6 lg:p-8"
            >
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    <CrmInputField
                        label="Product Name *"
                        name="productName"
                        value={formData.productName}
                        onChange={handleChange}
                    />

                    <div className="col-span-1 sm:col-span-2 lg:col-span-1">
                        <label className="block text-black font-semibold uppercase mb-1">
                            Product Code / Barcode
                        </label>
                        <div className="relative">
                            <input
                                type="text"
                                name="productCode"
                                value={formData.productCode}
                                onChange={handleChange}
                                className="w-full border p-2 rounded-lg pr-24"
                                placeholder="Enter or generate code"
                            />
                            <button
                                type="button"
                                onClick={generateCode}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-gray-600 hover:text-black bg-transparent"
                            >
                                Assign Code
                            </button>
                        </div>
                    </div>

                    <CrmInputField
                        label="HSN/SAC Code *"
                        name="hsnORsacCode"
                        value={formData.hsnORsacCode}
                        onChange={handleChange}
                    />

                    <CrmSelectField
                        label="Assign Product Unit *"
                        name="productUnit"
                        options={productUnits}
                        value={formData.productUnit}
                        onChange={handleChange}
                    />

                    <CrmInputField
                        label="Available Stock *"
                        name="availableStock"
                        value={formData.availableStock}
                        onChange={handleChange}
                        type="number"
                    />

                    <CrmSelectField
                        label="GST Rate *"
                        name="gstRate"
                        options={gstRates}
                        value={formData.gstRate}
                        onChange={handleChange}
                    />

                    <CrmInputField
                        label="Sale Price *"
                        name="salePrice"
                        value={formData.salePrice}
                        onChange={handleChange}
                        type="number"
                    />

                    <CrmInputField
                        label="Discount on Sale Price (%)"
                        name="discountPercentage"
                        value={formData.discountPercentage}
                        onChange={handleChange}
                        type="number"
                    />

                    <CrmInputField
                        label="Purchase Price"
                        name="purchasePrice"
                        value={formData.purchasePrice}
                        onChange={handleChange}
                        type="number"
                    />

                    <hr className="col-span-1 sm:col-span-2 lg:col-span-3 border-t border-gray-300 shadow-sm my-4" />
                </div>

                <div className="flex flex-col sm:flex-row justify-end sm:space-x-4 mt-6 space-y-2 sm:space-y-0">
                    <button
                        type="button"
                        className="px-6 py-2 rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300 w-full sm:w-auto"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isLoading}
                        className={`px-6 py-2 rounded-md text-white ${isLoading
                            ? "bg-green-400 cursor-not-allowed"
                            : "bg-green-700 hover:bg-green-800"
                            } w-full sm:w-auto`}
                    >
                        {isLoading ? "Saving..." : "Save"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CrmAddProduct;
